const searchClose = () => {
  const searchInput = document.getElementById('site-search__input');
  if (!searchInput) return
  searchInput.addEventListener('blur', () => {
    document.body.classList.remove('search-open')
  })
}

export default searchClose